import React from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import App from "./App.jsx";
import "./index.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  // Fail fast in dev so missing env var is obvious.
  // In CI builds without a real key, this warning shows but doesn't block.
  console.warn(
    "[endeavor] VITE_CLERK_PUBLISHABLE_KEY is not set. " +
    "Copy web/.env.example to web/.env.local and add your Clerk publishable key."
  );
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey || ""}
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// Register the service worker for app-shell caching + installability.
// Skipped in dev because Vite's dev server doesn't serve /sw.js with the
// right headers and we don't want to trap stale modules during hot reload.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        console.warn("SW registration failed:", err);
      });
  });
}
